// extracted by mini-css-extract-plugin
export default {"card":"Card_card__p9wzB","paddingNormal":"Card_paddingNormal__WBb-+","paddingLarge":"Card_paddingLarge__pAi+b"};